import { alpha } from '@mui/material/styles';

export function getUniqueScoreValues(scoreValues, fallback = [0, 1, 2, 3]) {
  const raw = Array.isArray(scoreValues) ? scoreValues : fallback;
  const uniq = Array.from(
    new Set((raw || []).map((v) => (v === null || v === undefined ? v : Number(v))))
  )
    .filter((v) => v !== null && v !== undefined && v !== '' && !Number.isNaN(Number(v)))
    .map((v) => Number(v));

  uniq.sort((a, b) => Number(a) - Number(b));
  return uniq;
}

export function scoreToneFromValue(value, orderedValues) {
  const values = (orderedValues || [])
    .slice()
    .map((v) => Number(v))
    .filter((v) => Number.isFinite(v));

  if (values.length <= 1) return 'primary';
  values.sort((a, b) => a - b);

  const idx = values.indexOf(Number(value));
  const t = idx <= 0 ? 0 : idx >= values.length - 1 ? 1 : idx / (values.length - 1);
  if (t <= 0.34) return 'warning';
  if (t <= 0.67) return 'info';
  return 'success';
}

export function scoreToggleButtonSx(tone) {
  return (theme) => {
    const safeTone = tone && theme.palette[tone] ? tone : 'primary';
    const main = theme.palette[safeTone]?.main || theme.palette.primary.main;
    const dark = theme.palette[safeTone]?.dark || theme.palette.text.primary;

    return {
      textTransform: 'none',
      fontWeight: 700,
      borderColor: theme.palette.divider,
      color: theme.palette.text.secondary,
      '&:hover': {
        borderColor: alpha(main, 0.35),
        bgcolor: alpha(main, 0.06),
      },
      '&.Mui-selected': {
        borderColor: alpha(main, 0.55),
        bgcolor: alpha(main, 0.14),
        color: dark,
      },
      '&.Mui-selected:hover': {
        borderColor: alpha(main, 0.65),
        bgcolor: alpha(main, 0.18),
      },
    };
  };
}
